import { Flex } from 'antd';
import clsx from 'clsx';
import type { MouseEventHandler, ReactNode } from 'react';

export interface ListyMetaRowProps {
  avatar: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  className?: string;
  onClick?: MouseEventHandler<HTMLElement>;
}

function hasDescription(description: ReactNode): description is ReactNode {
  return description != null && description !== false && description !== '';
}

/** Flex row that replicas `List.Item.Meta` (+ optional right actions). Does not wrap Listy. */
export default function ListyMetaRow({
  avatar,
  title,
  description,
  actions,
  className,
  onClick,
}: ListyMetaRowProps) {
  const showDescription = hasDescription(description);

  return (
    <Flex
      align="center"
      gap="middle"
      className={clsx('w-full min-w-0 px-0 py-2.5', className)}
      onClick={onClick}
    >
      <div className="shrink-0 self-center">{avatar}</div>
      <Flex vertical flex={1} gap={showDescription ? 2 : 0} className="min-w-0 justify-center">
        <div>{title}</div>
        {showDescription ? <div className="text-[10px]">{description}</div> : null}
      </Flex>
      {actions != null ? (
        <Flex align="center" className="shrink-0 self-center">
          {actions}
        </Flex>
      ) : null}
    </Flex>
  );
}
